export default {
  contract: {
    header: {
      title: "Non-disclosure agreement",
    },
    parties: {
      headline: "The parties",
      and: "and",
      label: {
        company: 'hereafter referred to as the "Disclosing Party" (Party 1)',
        supplier: 'hereafter referred to as the "Receiving Party" (Party 2)',
        cvr: "CVR no.:",
      },
      placeholder: {
        name: "[Name]",
        address: "[Address]",
        cvr: "[CVR no.]",
      },
    },
    agreement: {
      paragraphOne:
        "have entered into the following non-disclosure agreement regarding any confidential information Party 2 receives from Party 1 in connection with {description}",
      placeholder: {
        description: "[purpose]",
      },
    },
    confidentialInfo: {
      headline: "1. Confidential oplysninger",
      paragraphOne:
        '1.1 "Confidential information” means any information or data in any form (whether obtained in writing, orally or in any other form) regarding Party 1 or its business, including but not limited to production, operations, products, services, know-how, research, processes, technical information, tests, models, drawings and any similar information or data.',
      paragraphTwo:
        '1.2 "Confidential information" further means any information or data in any form (whether obtained in writing, orally or in any other form), including personal data, regarding Party 1’s employees and customers.',
      paragraphThree:
        '1.3 Finally, the fact that the parties are in ongoing discussions or negotiations regarding (purpose), including any terms, conditions and status hereof, is considered “confidential information".',
      paragraphFour:
        '1.4 "Confidential information" includes information and data in written and oral form as well as in any other form of representation.',
      paragraphFive:
        "1.5 Information that is publicly available is not considered confidential information.",
    },
    supplierObligations: {
      headline: "2. The Receiving Party's obligations",
      paragraphOne:
        "2.1 Party 2 undertakes the following in accordance with this non-disclosure agreement:",
      paragraphOne_1:
        "<i><strong>to</strong></i> hold any confidential information in complete and strict confidence and to not disclose such confidential information to any third party, unless (and only to the extent) disclosure is necessary to fulfil the purpose of this agreement, or if such confidential information is disclosed to Party 2’s legal or financial advisor or other advisors subject to separate laws of confidentiality,",
      paragraphOne_2:
        "<i><strong>to</strong></i> not store, copy, reproduce or distribute confidential information for its own or any third parties’ use (other than in accordance with this agreement),",
      paragraphOne_3:
        "<i><strong>to</strong></i> take reasonable measures to ensure that no documents or other data carriers containing confidential information is unintentionally removed in connection with Party’s 2 execution of any tasks agreed upon between the parties in accordance with the purpose of this agreement,",
      paragraphOne_4:
        "<i><strong>to</strong></i> use the confidential information solely for the purpose set out in this agreement, and",
      paragraphOne_5:
        "<i><strong>to</strong></i> return or destroy any material containing confidential information upon the request of Party 1.",
    },
    contractDuration: {
      headline: "3. Term and termination",
      paragraphOne:
        "This non-disclosure agreement will continue in effect as long as and to the extent information and data disclosed under the agreement is considered confidential information in accordance with clause 1. The agreement shall remain in force irrespective of whether the purpose set out in this agreement is no longer applicable.",
    },
    violation: {
      headline: "4. Breach",
      placeholder: {
        amount: "[amount]",
      },
      paragraphOne:
        "4.1 In case of Party 2’s breach of this agreement, Party 2 shall be obligated to pay to Party 1 a penalty in the amount of {amount} kr. for each individual breach, unless Party 1 can demonstrate an actual loss incurred in excess of [the penalty], in which case Party 2 will be liable for the full amount of damages incurred by Party 1",
      paragraphTwo:
        "4.2 Payment by Party 2 of a penalty or damages does not release Part 2 from the other obligations of this non-disclosure agreement.",
      paragraphThree:
        "4.3 Illegal acquisition, use and disclosure of trade secrets may further be sanctioned in accordance with the Danish Trade Secrets Act. In this connection, compensation may also be granted to Party 1 for non-pecuniary damage, cf. § 15, subsection 4 of the Danish Trade Secrets Act.",
    },
    applicableLaw: {
      headline: "5. Governing law",
      paragraphOne:
        "5.1 This non-disclosure agreement shall be governed by and construed in accordance with the laws of Denmark, excluding Danish rules on conflicts of law",
      paragraphTwo:
        "5.2 Any dispute that may arise in connection with this agreement must first try to be resolved through mediation through the Danish Mediation Institute in accordance with the rules in force at any given time for processing cases at the Danish Mediation Institute (www.mediationsinstituttet.dk).",
      paragraphThree:
        "5.3 In the event of a dispute between the parties, each party is entitled to submit a request to the Mediation Institute for commencement of mediation.",
      paragraphFour:
        "5.4 If the dispute cannot be resolved by mediation, each party is entitled to demand that the dispute must be settled {rules}.",
      placeholder: {
        rules: "[dispute must be settled by...]",
      },
      rulesValues: {
        voldgift:
          "by arbitration in accordance with the rules of the Danish Arbitration Institute",
        retten: "by the ordinary Danish courts",
      },
    },
    signature: {
      date_label: "Date:",
      company1_label: "Company name [Party 1]: ",
      company2_label: "Company name [Party 2]: ",
      signature_label: "Name [Signature]:",
    },
  },
};



// WEBPACK FOOTER //
// ./src/apps/hemmelig/translations/contract/en_contract.js